<template>
  <el-card class="h-full relative">
    <div class="h-full flex flex-col" v-if="!isSHowPaper" v-loading="loading">
      <div class="flex mb-20px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="考试名称"
          maxlength="50"
          v-model="searchData.ExamName"
          clearable
        ></el-input>
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="考试编号"
          maxlength="50"
          v-model="searchData.ExamCode"
          clearable
        ></el-input>
        <el-button size="small" @click="resetText()">重置</el-button>
        <el-button size="small" type="primary" @click="sizeChange()">搜索</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="batchExportLoading"
          @click="batchExport()"
          :disabled="!$hasAccess('export')"
          >导出</el-button
        >
      </div>
      <el-table
        :data="examDataList"
        border
        class="w-full"
        :height="tableHeight"
        ref="tableRef"
        stripe
        row-key="unique"
        :tree-props="{
          children: 'taskExamAnswerRecordManageSessionDtos',
          hasChildren: 'hasChildren',
        }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" align="center"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="考试名称" prop="ExamName" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="知识点"
          prop="ChapterName"
          min-width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="考试编号" prop="ExamCode" show-overflow-tooltip></el-table-column>
        <el-table-column label="考生姓名" prop="Name" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="实际考试开始时间"
          prop="RealExamStartTime"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="实际考试结束时间"
          prop="RealExamEndTime"
          min-width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="是否通过" prop="IsPass" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.IsPass === 1 ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否补考" prop="ReExam" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.ReExam === 1 ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column width="70" label="得分" prop="Score" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" width="210" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="viewInfo(scope.row)" :disabled="!$hasAccess('viewPaper')"
              >查看试卷</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="flex justify-end mt-20px">
        <el-pagination
          background
          @size-change="sizeChange"
          @current-change="searchList"
          :current-page.sync="page.pageNo"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :page-size.sync="page.pageSize"
          :total="page.pageTotal"
        ></el-pagination>
      </div>
    </div>
    <div v-if="isSHowPaper" class="h-full">
      <el-page-header @back="returnBack" content="试卷"></el-page-header>
      <!-- <div
        class="w-1000px m-auto relative"
        style="height:calc( 100% - 30px );border: dashed 1px #999"
      >
        <PaperCom :renderData.sync="renderData" :originData="originData" />
      </div>
      <el-button
        @click="download([originData.id], originData.content.examName)"
        size="small"
        type="primary"
        class="absolute right-20px top-20px"
        >下载</el-button
      > -->
      <AnswerSheet class="h-[calc(100%-32px)]" :id="currentRow.PaperId" />
    </div>
  </el-card>
</template>

<script>
import DiyService from '@/modules/educational-training-management-sm/services/DiyService'
import dayjs from 'dayjs'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'
import AnswerSheet from '../../components/examManageConstructionUnit/AnswerSheet'

export default {
  name: 'examine-paper',
  components: { DepartmentSelect, AnswerSheet },
  data() {
    return {
      // 设备设施清单
      examDataList: [],
      searchData: {
        ExamName: '',
        ExamCode: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      selection: [],
      batchExportLoading: false,
      currentRow: {},
      isSHowPaper: false,
      loading: false,
      showJoinExamDialogVisible: false,
      isShowDialog: false,
    }
  },
  filters: {
    showText(val) {
      return val ? dayjs(val).format('YYYY-MM-DD HH:mm:ss') : ''
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
  },
  methods: {
    handleSelectionChange(selection) {
      this.selection = selection
    },
    async batchExport() {
      if (this.batchExportLoading) return

      if (!this.selection || this.selection.length === 0) {
        this.$message.warning('请选择要导出的数据')
        return
      }

      this.batchExportLoading = true
      this.loading = true
      try {
        const params = {
          ...this.searchData,
          IdList: this.selection
            .map((item) => {
              return item.TaskId
            })
            .join(','),
          ApiEngineKey: 'export_exam_record_list',
        }
        const res = await DiyService.getInterfaceList(params)
        if (res[1].Code === 1) {
          if (!res[1].Data?.FileByteBase64) {
            this.$message.error('导出数据格式错误')
            return
          }
          try {
            const binaryString = window.atob(res[1].Data.FileByteBase64)
            const bytes = new Uint8Array(binaryString.length)
            for (let i = 0; i < binaryString.length; i++) {
              bytes[i] = binaryString.charCodeAt(i)
            }
            const blob = new Blob([bytes], {
              type:
                res[1].Data.ContentType ||
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = res[1].Data.FileName || `考试记录${dayjs().format('YYYY-MM-DD')}.xlsx`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          } catch (decodeError) {
            this.$message.error('文件解码失败')
          }
        } else {
          this.$message.error(res[1].Msg || '导出失败')
        }
      } catch (error) {
        this.$message.error('导出失败')
      } finally {
        this.batchExportLoading = false
        this.loading = false
      }
    },
    // 查看
    viewInfo(data) {
      this.currentRow = data
      this.isSHowPaper = true
    },
    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.sizeChange()
    },
    /**
     * @description 分页数改变
     */
    sizeChange() {
      this.page.pageNo = 1
      this.searchList()
    },
    // 列表
    async searchList() {
      const data = {
        ApiEngineKey: 'get_exam_record_list',
        PageSize: this.page.pageSize,
        PageIndex: this.page.pageNo,
        ...this.searchData,
      }
      this.loading = true
      const [err, res] = await DiyService.getInterfaceList(data)
      this.loading = false
      if (!err && res.Code === 1) {
        this.examDataList = res.Data
        this.page.pageTotal = res.DataCount
      } else {
        this.$message.error(res.Msg)
      }
    },
    returnBack() {
      this.isSHowPaper = false
      if (this.isShowDialog) {
        this.showJoinExamDialogVisible = true
      }
    },
  },
  mounted() {
    this.searchList()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
